// extracted by mini-css-extract-plugin
var _1 = "ModalClose__bg--a0pVK";
var _2 = "ModalClose__border--Sz0Qc";
var _3 = "ModalClose__fallback--J9Ep6 ModalClose__main--j3FI7";
var _4 = "ModalClose__main--j3FI7";
var _5 = "ModalClose__x--ew2Bh";
export { _1 as "bg", _2 as "border", _3 as "fallback", _4 as "main", _5 as "x" }
